// extracted by mini-css-extract-plugin
export default {"wrap":"PageHeader_wrap__VqDkY","eyebrow":"PageHeader_eyebrow__7geJB","title":"PageHeader_title__QKSV3","subtitle":"PageHeader_subtitle__matVs","actions":"PageHeader_actions__k+knC"};